import {
    /** FETCH PROFESSIONS  */
    FETCH_PATIENTREGISTER_FULFILLED,
    FETCH_PATIENTREGISTER_REJECTED,
    FETCH_PATIENTREGISTER_PENDING,
    RESET_PATIENTREGISTER,
} from "../../actions/auth/patientRegister";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PATIENTREGISTER_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_PATIENTREGISTER_FULFILLED:
            localStorage.setItem("accessToken", action.payload.accessToken)
            localStorage.setItem("refreshToken", action.payload.refreshToken)
            return {
                ...state,
                patientRegister: action.payload,
                done: true,
                error: false,
                spinner: false
            };
        case FETCH_PATIENTREGISTER_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_PATIENTREGISTER:
            return {
                initialState,
                spinner: false,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};